import { styled, createTheme } from '@mui/material/styles';
import React from 'react';
import { SvgIcon } from '@mui/material';
import logger from '@next/core-logger';

class ThemeColor {
    constructor() {
        this.font = {
            primary: {
                regular: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                    letterSpacing: 0,
                },
                light: { family: "", filename: "", formats: [], weight: 400, letterSpacing: 0 },
                medium: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                    letterSpacing: 0,
                },
                italic: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                    letterSpacing: 0,
                },
                bold: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 600,
                    letterSpacing: 0,
                },
                compressedMedium: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 600,
                    letterSpacing: 0,
                },
                thin: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                    letterSpacing: 0,
                },
            },
            secondary: {
                regular: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                },
                light: { family: "", filename: "", formats: [], weight: 400 },
                medium: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                },
                italic: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 400,
                },
                bold: {
                    family: "",
                    filename: "",
                    formats: [],
                    weight: 800,
                },
            },
            default: '"Helvetica Neue", Arial, sans-serif',
        };
        this.typography = {
            h1: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
                textDecoration: "",
            },
            h2: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            h3: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            h4: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            h5: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            h6: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body1: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body2: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body3: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body4: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body5: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            body6: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            subtitle1: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            subtitle2: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            overline: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "1",
                lineHeight: "0",
            },
            caption: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
        };
        this.component = {
            buttonMedium: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            buttonLarge: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
        };
        this.form = {
            buttonPrimary: {
                border: "",
                background: "",
                color: "",
                radius: "",
                opacity: "",
                fontSize: "",
                fontWeight: "",
                textTransform: "",
                letterSpacing: "",
            },
            buttonSecondary: {
                border: "",
                borderRadius: "",
                background: "",
                color: "",
                radius: "",
                opacity: "",
                fontSize: "",
            },
            buttonTertiary: {
                border: "",
                background: "",
                color: "",
                radius: "",
                opacity: "",
                fontSize: "",
            },
            input: {
                radius: "",
                borderRadius: "",
                background: "",
                color: "",
                border: "",
                borderBottom: "",
                borderTop: "",
                borderColor: "",
                placeholder: "",
                sortPlaceholder: "",
                text: "",
                focusActive: {
                    background: "",
                    boxShadow: "",
                    borderWidth: "",
                    borderColor: "",
                    border: "",
                },
                hover: {
                    background: "",
                    boxShadow: "",
                    borderWidth: "",
                    borderColor: "",
                    border: "",
                },
            },
            default: {
                border: "",
                background: "",
                radius: "",
            },
            disabled: {
                border: "",
                background: "",
                radius: "",
            },
            focusActive: {
                border: "",
                background: "",
                radius: "",
            },
            invalid: {
                border: "",
                background: "",
                radius: "",
            },
            selectedAccent: {
                border: "",
                background: "",
                radius: "",
            },
            selectedBlock: {
                border: "",
                background: "",
                radius: "",
            },
            success: {
                border: "",
                background: "",
                radius: "",
            },
        };
        this.borders = {
            primary: {
                border: "",
                radius: "",
            },
            secondary: {
                border: "",
                radius: "",
            },
        };
        this.palette = {
            primary: {
                main: "",
                dark: "",
                light: "",
                contrastText: "",
                shades: {
                    disabled: "",
                },
            },
            secondary: {
                main: "",
                dark: "",
                light: "",
                contrastText: "",
                shades: {
                    disabled: "",
                },
            },
            modal: {
                background: {
                    primary: "",
                    secondary: "",
                },
            },
            action: {
                disabledBorder: "",
                enabledBorder: "",
                disabledBackground: "",
                enabledBackground: "",
                disabled: "",
            },
            info: {
                main: "",
                other: {
                    focusRingColor: "",
                    focusBorderRadius: "",
                },
            },
            text: {
                primary: "",
                secondary: "",
            },
            divider: "",
        };
        this.text = {
            default: "",
            disabled: "",
            reversed: "",
            error: "",
            hyperlink: "",
            muted: "",
            strong: "",
            success: "",
            warning: "",
            search: "",
            navigation: {
                link: "",
                linkActive: "",
                linkClearance: "",
                fontWeight: 0,
            },
        };
        this.drawer = {
            headerBorder: "",
            headerBackground: "",
        };
        this.plp = {
            h1Count: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
                textDecoration: "",
            },
            tileLabel1: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            tileLabel2: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            tileLabel3: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            tileLabel4: {
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            layout: {
                flexDirection: "",
                hasColourChips: "",
                hasBrandName: "",
            },
            listing: {
                textAlign: "",
            },
            facetDivider: "",
            filters: {
                titleTransform: "",
                clearBtnBorderWidth: "",
            },
            colourChipSizes: {
                maxHeight: "",
                maxWidth: "",
                width: "",
                height: "",
                selectedHeight: "",
                selectedWidth: "",
            },
            searchBannerContainer: {
                backgroundColor: "",
                roundelsBorderRadius: "",
                roundelsBorder: "",
                ctasBorderRadius: "",
                ctasBorder: "",
                ctasBorderBottom: "",
                textAlignment: "",
                copyLineClamp: "",
                fontSize: "",
            },
            searchBanner: {
                default: {
                    banner: {
                        root: {
                            backgroundColor: "",
                        },
                        copyText: {
                            textColor: "",
                            link: {
                                primary: {
                                    enabled: {
                                        contrastTextColor: "",
                                        hovered: {
                                            contrastTextColor: "",
                                        },
                                    },
                                },
                            },
                        },
                        chips: {
                            outlined: {
                                enabled: {
                                    backgroundColor: "",
                                    borderColor: "",
                                    contrastTextColor: "",
                                },
                                hovered: {
                                    backgroundColor: "",
                                    borderColor: "",
                                    contrastTextColor: "",
                                },
                            },
                        },
                        imageChips: {
                            backgroundColor: "",
                            textColor: "",
                            enabled: {
                                borderColor: "",
                            },
                            hovered: {
                                borderColor: "",
                            },
                        },
                    },
                    stripBanner: {
                        backgroundColor: "",
                        borderColor: "",
                        button: {
                            backgroundColor: "",
                            borderColor: "",
                            contrastTextColor: "",
                        },
                        typography: {
                            textColor: "",
                        },
                    },
                },
                searchListItemLabel: {
                    fontFamily: "",
                    fontWeight: "",
                    textTransform: "",
                    textDecoration: "",
                    fontSize: "",
                    letterSpacing: "",
                    lineHeight: "",
                },
                chip: {
                    fontFamily: "",
                    fontWeight: 400,
                    border: "",
                    textTransform: "",
                    textDecoration: "",
                    fontSize: "",
                    letterSpacing: 0,
                    lineHeight: 1.5,
                    small: {
                        borderRadius: "",
                    },
                    medium: {
                        borderRadius: "",
                    },
                },
                imageChip: {
                    default: {
                        borderRadius: "",
                    },
                },
            },
        };
        this.footer = {
            socialMedia: {
                background: "",
            },
            quickLinks: {
                background: "",
            },
            mainLinks: {
                background: "",
            },
            copyright: {
                background: "",
            },
            accordians: {
                background: "#f7f7f7",
            },
        };
        this.header = {
            navUpperBackground: {
                default: "",
                color: "",
            },
            navLowerBackground: {
                default: "",
                desktop: "",
                active: "",
                borderBottom: "",
                borderTop: "",
            },
            shoppingBag: {
                color: "",
                fontWeight: "",
                fontSize: "",
                promotionColor: "",
                deliveryColor: "",
                textTransform: "",
                items: {
                    backgroundColour: "",
                    fontSize: "",
                    color: "",
                },
                divider: {
                    borderBottom: "",
                },
            },
            myAccount: {
                background: "",
                radius: "",
                color: "",
                header: {
                    backgroundColour: "",
                },
                content: {
                    backgroundColour: "",
                    textTransform: "",
                },
                divider: {
                    border: "",
                },
            },
            autoCompleteButton: {
                backgroundcolor: "",
                color: "",
                radius: "",
            },
            snailItemUnderline: {
                border: "",
            },
            globalAppBar: {
                background: "",
            },
            upperHeader: {
                color: "",
                fontSize: "",
            },
            enrichedSearch: {
                background: "",
            },
            simpleSearch: {
                marginTop: "",
                padding: "",
                radius: "",
                boxShadow: "",
            },
            burgerMenuQuickLinks: {
                background: "",
                fontFamily: "",
                fontWeight: 400,
                textTransform: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: 1.5,
            },
            burgerMenu: {
                borderBottom: "",
            },
            directLink: {
                fontSize: "",
                fontWeight: "",
            },
        };
        this.popover = {
            border: "",
            radius: "",
            backgroundColour: "",
            fontSize: "",
            boxShadow: "",
            header: {
                backgroundColour: "",
                borderBottom: "",
            },
            arrow: {
                boxShadow: "",
                background: "",
            },
        };
        this.utilities = {
            divider: "",
            dividerDark: "",
            backgroundAccent: "",
            activeBorder: "",
            chipBorderRadius: "",
            background: {
                default: "",
                paper: "",
            },
        };
        this.countrySelect = {
            logoPosition: "",
            headerBarHeight: "",
            headerBackground: "",
            headerBorderBottom: "",
            accordionHeaderTransform: "",
            accordionHeaderLetterSpacing: "",
        };
        this.checkbox = {
            border: {
                default: "",
                active: "",
                radius: "",
            },
            size: "",
        };
        this.other = {
            ratingHover: "",
            ratingInactive: "",
            ratingActive: "",
            notification: "",
            divider: "",
        };
        this.accordion = {
            background: "",
            border: {
                width: "",
                color: "",
                radius: "",
                style: "",
            },
            accordionDetailsPadding: "",
        };
        this.select = {
            borderColor: "",
            borderRadius: "",
        };
        this.components = {
            borderRadius: "",
            tabText: {
                fontSize: "",
                fontFamily: "",
                fontWeight: "",
                textTransform: "",
                letterSpacing: "",
            },
            tab: {
                nav: {
                    default: {
                        active: {
                            highlightColor: "",
                        },
                    },
                },
            },
            inputLabel1: {
                fontFamily: "",
                fontWeight: "0",
                textTransform: "",
                textDecoration: "",
                fontSize: "",
                letterSpacing: "0",
                lineHeight: "0",
            },
            inputLabel2: {
                fontFamily: "",
                fontWeight: "0",
                fontSize: "",
                lineHeight: "0",
                textTransform: "",
            },
            buttonLarge: {
                fontFamily: "",
                fontWeight: "0",
                fontSize: "",
                lineHeight: "0",
                textTransform: "",
                letterSpacing: "0",
            },
            buttonMedium: {
                fontSize: "",
                fontFamily: "",
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: "",
                textTransform: "",
            },
            buttonGroup: {
                default: {
                    borderTopColor: "",
                    borderBottomColor: "",
                },
            },
            toggleButton: {
                selected: {
                    default: {
                        background: "",
                        borderColor: "",
                    },
                },
            },
            dialog: {
                dialogHeader: {
                    default: {
                        backgroundColor: "",
                        borderColor: "",
                        textColor: "",
                        iconColor: "",
                    },
                },
            },
            link: {
                primary: {
                    enabled: {
                        color: "",
                        textColor: "",
                    },
                },
            },
            button: {
                outlined: {
                    secondary: {
                        enabled: {
                            contrastTextColor: "",
                        },
                    },
                },
            },
            inputText: {
                fontFamily: "",
                fontSize: "",
                fontWeight: 400,
                lineHeight: 1.5,
                letterSpacing: "",
            },
            chips: {
                filled: {
                    newin: {
                        enabled: {
                            backgroundColor: "transparent",
                            color: "#000000",
                        },
                    },
                },
            },
            chipLabel2: {
                fontFamily: "",
                fontWeight: 0,
                textTransform: "",
                textDecoration: "",
                fontSize: "",
                letterSpacing: "",
                lineHeight: "",
            },
            breadcrumb: {
                default: {
                    backgroundColor: "rgba(247, 247, 247, 1)",
                    borderBottomColor: "rgba(238, 238, 238, 1)",
                    borderTopColor: "rgba(238, 238, 238, 1)",
                    gradientLeft: "linear-gradient(to right, rgba(247, 247, 247, 1), rgba(247, 247, 247, 0))",
                    gradientRight: "linear-gradient(to right, rgba(247, 247, 247, 0), rgba(247, 247, 247, 1))",
                    button: {
                        enabled: {
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderTopColor: "rgba(238, 238, 238, 0)",
                            borderBottomColor: "rgba(238, 238, 238, 0)",
                            borderLeftColor: "rgba(238, 238, 238, 1)",
                            borderRightColor: "rgba(238, 238, 238, 1)",
                            contrastTextColor: "rgba(0, 0, 0, 1)",
                            iconColor: "rgba(0, 0, 0, 1)",
                        },
                        hovered: {
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            borderTopColor: "rgba(238, 238, 238, 0)",
                            borderBottomColor: "rgba(238, 238, 238, 0)",
                            borderLeftColor: "rgba(238, 238, 238, 1)",
                            borderRightColor: "rgba(238, 238, 238, 1)",
                            contrastTextColor: "rgba(0, 0, 0, 1)",
                            iconColor: "rgba(0, 0, 0, 1)",
                        },
                    },
                },
            },
            backToNext: {
                default: {
                    backgroundColor: "rgba(0, 0, 0, 1)",
                    textColor: "rgba(255, 255, 255, 1)",
                    iconColor: "rgba(255, 255, 255, 1)",
                },
            },
            menu: {
                default: {
                    root: {
                        borderColor: "rgba(222, 222, 222, 1)",
                        backgroundColor: "rgba(255, 255, 255, 1)",
                    },
                    disabled: {
                        textColor: "rgba(179, 179, 179, 1)",
                    },
                    hovered: {
                        backgroundColor: "rgba(102, 102, 102, 1)",
                        textColor: "rgba(255, 255, 255, 1)",
                    },
                    selected: {
                        backgroundColor: "rgba(102, 102, 102, 1)",
                        textColor: "rgba(255, 255, 255, 1)",
                    },
                    enabled: {
                        textColor: "rgba(0, 0, 0, 1)",
                    },
                },
                megaMenu: {
                    mission: {
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        textColor: "rgba(0, 0, 0, 1)",
                    },
                },
            },
            appBar: {
                brandBar: {
                    default: {
                        tab: {
                            default: {
                                enabled: {
                                    borderColor: "#FFFFFF",
                                },
                                active: {
                                    borderColor: "#000000",
                                },
                            },
                        },
                    },
                },
            },
            saleClearance: {
                sale: {
                    bannerBackgroundColour: "rgba(245, 245, 245, 1)",
                    sashColour: "rgba(208, 26, 66, 1)",
                },
                clearance: {
                    bannerBackgroundColour: "rgba(243, 221, 193, 1)",
                    sashColour: "rgba(239, 122, 34, 1)",
                },
            },
        };
        this.backdrop = {
            default: {
                main: "",
            },
        };
        this.brand = {
            sale: {
                default: {
                    textColor: "",
                },
            },
            markdown: {
                default: {
                    textColor: "",
                },
            },
            success: {
                default: {
                    textColor: "",
                },
            },
        };
        this.background = {
            default: "",
            paper: {
                background: "",
            },
        };
        this.action = {
            default: {
                enabled: {
                    background: "",
                    borderColor: "",
                },
            },
            focused: {
                border: "",
            },
            disabled: {
                border: "",
            },
        };
        this.light = {
            text: {
                primary: "#000000",
                secondary: "#000000",
            },
        };
        this.grey = {
            50: "",
            100: "",
            300: "",
            500: "",
            700: "",
        };
    }
}

const buildFont = (fontFamily, format, url) => `url("${url}/${fontFamily}.${format}") format('${format}')`;
const fontBuilder = (fontFamily, url) => (...formats) => {
    return formats.map(format => buildFont(fontFamily, format, url)).join(", ");
};
const str = (family, filename, formats, url) => {
    if (filename)
        return `src: ${fontBuilder(filename, url)(...formats)};`;
    return `src: local(${family});`;
};
const FONTS = (theme, url, containerId) => `
    <style id="font-ssr-styles-${containerId}" type="text/css">
        @font-face {
            font-family: ${theme.font.primary.light.family};
            ${str(theme.font.primary.light.family, theme.font.primary.light.filename, theme.font.primary.light.formats, url)}
            font-weight: ${theme.font.primary.light.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.regular.family};
            ${str(theme.font.primary.regular.family, theme.font.primary.regular.filename, theme.font.primary.regular.formats, url)}
            font-weight: ${theme.font.primary.regular.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.medium.family};
            ${str(theme.font.primary.medium.family, theme.font.primary.medium.filename, theme.font.primary.medium.formats, url)}
            font-weight: ${theme.font.primary.medium.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.bold.family};
            ${str(theme.font.primary.bold.family, theme.font.primary.bold.filename, theme.font.primary.bold.formats, url)}
            font-weight: ${theme.font.primary.bold.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.italic.family};
            ${str(theme.font.primary.italic.family, theme.font.primary.italic.filename, theme.font.primary.italic.formats, url)}
            font-weight: ${theme.font.primary.italic.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.compressedMedium.family};
            ${str(theme.font.primary.compressedMedium.family, theme.font.primary.compressedMedium.filename, theme.font.primary.compressedMedium.formats, url)}
            font-weight: ${theme.font.primary.compressedMedium.weight};
        }
        @font-face {
            font-family: ${theme.font.primary.thin.family};
            ${str(theme.font.primary.thin.family, theme.font.primary.thin.filename, theme.font.primary.thin.formats, url)}
            font-weight: ${theme.font.primary.thin.weight};
        }
        @font-face {
            font-family: ${theme.font.secondary.light.family};
            ${str(theme.font.secondary.light.family, theme.font.secondary.light.filename, theme.font.secondary.light.formats, url)}
            font-weight: ${theme.font.secondary.light.weight};
        }
        @font-face {
            font-family: ${theme.font.secondary.regular.family};
            ${str(theme.font.secondary.regular.family, theme.font.secondary.regular.filename, theme.font.secondary.regular.formats, url)}
            font-weight: ${theme.font.secondary.regular.weight};
        }
        @font-face {
            font-family: ${theme.font.secondary.medium.family};
            ${str(theme.font.secondary.medium.family, theme.font.secondary.medium.filename, theme.font.secondary.medium.formats, url)}
            font-weight: ${theme.font.secondary.medium.weight};
        }
        @font-face {
            font-family: ${theme.font.secondary.italic.family};
            ${str(theme.font.secondary.italic.family, theme.font.secondary.italic.filename, theme.font.secondary.italic.formats, url)}
            font-weight: ${theme.font.secondary.italic.weight};
        }
        @font-face {
            font-family: ${theme.font.secondary.bold.family};
            ${str(theme.font.secondary.bold.family, theme.font.secondary.bold.filename, theme.font.secondary.bold.formats, url)}
            font-weight: ${theme.font.secondary.bold.weight};
        }
        ${containerId.includes("#") ? containerId : `#${containerId}`} {
            font-family: ${theme.font.primary.regular.family}, ${theme.font.default};
        }
    </style>`;

const breakpoints = {
    values: {
        xs: 0,
        sm: 400,
        md: 768,
        lg: 1024,
        xl: 1280,
        xxl: 1440,
    },
};

function link() {
    return {
        MuiLink: {
            defaultProps: {
                underline: "hover",
            },
        },
    };
}

const EmptyCheckboxComponent = styled("span") `
    width: 1.25em;
    height: 1.25em;
    background-size: 0.75em auto;
    background-color: ${({ theme }) => theme.colours.palette.action.enabledBackground};
    border: ${({ theme }) => theme.colours.checkbox.border.default};
    border-radius: ${({ theme }) => theme.colours.checkbox.border.radius};
    box-sizing: border-box;
`;
function EmptyCheckbox() {
    return React.createElement(EmptyCheckboxComponent, null);
}
const CheckedCheckboxComponent = styled(EmptyCheckboxComponent) `
    background-image: url("/static-content/icons/shared/check-active.svg");
    background-repeat: no-repeat;
    background-position: center;
    border: ${({ theme }) => theme.colours.checkbox.border.active};
`;
function CheckedCheckbox() {
    return React.createElement(CheckedCheckboxComponent, null);
}
const IndeterminateCheckboxComponent = styled(EmptyCheckboxComponent) `
    background-image: url("/static-content/icons/shared/check-indeterminate.svg");
    background-repeat: no-repeat;
    background-position: center;
    border: ${({ theme }) => theme.colours.checkbox.border.active};
`;
function IndeterminateCheckbox() {
    return React.createElement(IndeterminateCheckboxComponent, null);
}
function checkbox(theme) {
    return {
        MuiCheckbox: {
            defaultProps: {
                icon: React.createElement(EmptyCheckbox, null),
                checkedIcon: React.createElement(CheckedCheckbox, null),
                indeterminateIcon: React.createElement(IndeterminateCheckbox, null),
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    color: theme.palette.action.enabledBorder,
                    fontFamily: theme.font.primary.regular.family,
                    fontSize: `${theme.font.primary.regular.family}, ${theme.font.default}`,
                    "&.Mui-disabled": { opacity: 0.3 },
                    "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: theme.palette.primary.main,
                    },
                    "&.Mui-focusVisible": {
                        backgroundColor: "transparent",
                        borderRadius: theme.palette.info.other.focusBorderRadius,
                        outlineOffset: "-0.5rem",
                        outline: `0.125rem solid ${theme.palette.info.other.focusRingColor}`,
                    },
                    "&&:hover": {
                        backgroundColor: "transparent",
                        color: theme.palette.primary.dark,
                        borderColor: theme.palette.primary.dark,
                    },
                },
            },
        },
    };
}

function formControlLabel(theme) {
    return {
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    "&.Mui-disabled": {
                        color: theme.palette.action.disabled,
                    },
                },
            },
        },
    };
}

const ChevronComponent = (props) => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("use", { href: "/static-content/icons/shared/chevron-down-light.svg#chevron-light" })));
};
function StarIcon(props) {
    return (React.createElement(SvgIcon, Object.assign({}, props, { viewBox: "0 0 12 12" }),
        React.createElement("use", { href: "/static-content/icons/shared/ui-star-rounded-large.svg#ui-star-rounded-large" })));
}

function select(theme) {
    return {
        MuiSelect: {
            defaultProps: {
                IconComponent: ChevronComponent,
            },
            styleOverrides: {
                select: {
                    borderRadius: theme.select.borderRadius,
                    padding: "0.75rem 1rem",
                    "&.MuiInputBase-inputSizeSmall": {
                        padding: "0.5rem 1rem",
                    },
                },
                root: {
                    "&.Mui-disabled > svg": {
                        color: "#BDBDBD",
                    },
                    borderRadius: theme.select.borderRadius,
                    cursor: "pointer",
                    '&[alignment="rtl"] > svg': { right: "unset", left: 15 },
                    "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline ": {
                        borderColor: "#000",
                        borderWidth: "1px",
                    },
                },
            },
        },
    };
}

const ICON_SMALL = { width: 12, height: 12 };
const ICON_MEDIUM = { width: 16, height: 16 };
const ICON_LARGE = { width: 20, height: 20 };
function Rating(theme) {
    return {
        MuiRating: {
            defaultProps: {
                emptyIcon: React.createElement(StarIcon, null),
                icon: React.createElement(StarIcon, null),
                value: 4,
                readOnly: true,
                precision: 0.5,
                size: "small",
            },
            styleOverrides: {
                root: { gap: "2px" },
                iconEmpty: { color: theme.other.ratingInactive },
                iconFilled: { color: theme.other.ratingActive },
                iconHover: { color: theme.other.ratingHover },
                sizeSmall: {
                    "& svg": Object.assign({}, ICON_SMALL),
                    fontSize: theme.text.default,
                },
                sizeMedium: {
                    "& svg": Object.assign({}, ICON_MEDIUM),
                    fontSize: theme.text.default,
                },
                sizeLarge: {
                    "& svg": Object.assign({}, ICON_LARGE),
                },
            },
        },
    };
}

function accordion(theme) {
    return {
        MuiAccordion: {
            defaultProps: { disableGutters: true, square: true },
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    borderWidth: theme.accordion.border.width,
                    borderColor: theme.accordion.border.color,
                    borderRadius: theme.accordion.border.radius,
                    borderStyle: theme.accordion.border.style,
                    "&.Mui-disabled": {
                        backgroundColor: theme.accordion.background,
                        color: theme.palette.primary.shades.disabled,
                        opacity: 1,
                    },
                },
            },
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    padding: 0,
                    maxHeight: "2.25rem",
                    "@media (min-width: 1024px)": {
                        maxHeight: "2.75rem",
                    },
                    "&.Mui-expanded": {
                        maxHeight: "2.25rem",
                        "@media (min-width: 1024px)": {
                            maxHeight: "2.75rem",
                        },
                    },
                    "& .MuiAccordionSummary-expandIcon": {
                        "& > span:last-child": {
                            display: "none",
                        },
                    },
                },
            },
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: theme.accordion.accordionDetailsPadding,
                },
            },
        },
    };
}

function ComponentOverrides(theme) {
    return Object.assign(link(), checkbox(theme), formControlLabel(theme), Rating(theme), select(theme), accordion(theme));
}

const nextMaterialUITheme = (theme, textAlignment) => {
    const createdTheme = createTheme({
        direction: textAlignment,
        breakpoints,
        typography: {
            fontFamily: `${theme.font.primary.regular.family}, ${theme.font.default}`,
            h1: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "1.5rem",
                letterSpacing: "0.0075rem",
                lineHeight: 1.5,
                fontWeight: theme.font.primary.medium.weight,
            },
            h2: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "1.25rem",
                letterSpacing: "0.0075rem",
                lineHeight: 1.5,
                fontWeight: theme.font.primary.medium.weight,
            },
            h3: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "1rem",
                letterSpacing: "0.0075rem",
                lineHeight: 1.5,
                fontWeight: theme.font.primary.medium.weight,
            },
            h4: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "0.938rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
                fontWeight: theme.font.primary.medium.weight,
            },
            h5: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "0.875rem",
                letterSpacing: "0.0075rem",
                lineHeight: 1.5,
                fontWeight: theme.font.primary.medium.weight,
            },
            h6: {
                fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
                fontWeight: theme.font.primary.medium.weight,
            },
            subtitle1: {
                color: theme.text.default,
                fontSize: "0.875rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            subtitle2: {
                color: theme.text.default,
                fontSize: "0.875rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body1: {
                color: theme.text.default,
                fontSize: "0.875rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body2: {
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body3: {
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body4: {
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body5: {
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
            body6: {
                color: theme.text.default,
                fontSize: "0.75rem",
                lineHeight: 1.5,
                letterSpacing: "0.0075rem",
            },
        },
        palette: {
            primary: {
                light: theme.palette.primary.light,
                main: theme.palette.primary.main,
                dark: theme.palette.primary.dark,
                contrastText: theme.palette.primary.contrastText,
            },
            secondary: {
                light: theme.palette.secondary.light,
                main: theme.palette.secondary.main,
                dark: theme.palette.secondary.dark,
                contrastText: theme.palette.secondary.contrastText,
            },
            error: {
                main: theme.text.error,
            },
            warning: {
                main: theme.text.warning,
            },
            success: {
                main: theme.text.success,
            },
            action: {
                disabledOpacity: 0.5,
            },
            divider: theme.palette.divider,
        },
        components: Object.assign({ MuiTypography: {
                defaultProps: {
                    variantMapping: {
                        h1: "h1",
                        h2: "h1",
                        h3: "h1",
                        h4: "h2",
                        h5: "h3",
                        h6: "h4",
                    },
                },
            }, MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: `${theme.font.primary.medium.family}, ${theme.font.default}`,
                        textTransform: "none",
                        fontSize: "0.875rem",
                        lineHeight: 1.5,
                        letterSpacing: "0.0075rem",
                        fontWeight: theme.font.primary.medium.weight,
                        background: theme.form.buttonPrimary.background,
                        color: theme.form.buttonPrimary.color,
                        borderRadius: theme.form.buttonPrimary.radius,
                        border: theme.form.buttonPrimary.border,
                        "&:focus": {
                            border: theme.form.focusActive.border,
                            background: theme.form.focusActive.background,
                            borderRadius: theme.form.focusActive.radius,
                        },
                        "&:active": {
                            border: theme.form.selectedBlock.border,
                            background: theme.form.selectedBlock.background,
                            borderRadius: theme.form.selectedBlock.radius,
                        },
                        "&:disabled": {
                            border: theme.form.disabled.border,
                            background: theme.form.disabled.background,
                            borderRadius: theme.form.disabled.radius,
                        },
                    },
                },
                defaultProps: {
                    disableRipple: true,
                    disableTouchRipple: true,
                    disableFocusRipple: true,
                },
            }, MuiAccordion: {
                styleOverrides: {
                    root: {
                        backgroundColor: theme.utilities.backgroundAccent,
                    },
                },
            }, MuiListItem: {
                styleOverrides: {
                    root: {
                        "&.Mui-selected": { backgroundColor: theme.utilities.backgroundAccent },
                        "&.Mui-selected:hover": { backgroundColor: theme.utilities.backgroundAccent },
                    },
                },
            }, MuiTabs: {
                defaultProps: {
                    disableRipple: true,
                    disableTouchRipple: true,
                },
            }, MuiTab: {
                defaultProps: {
                    disableRipple: true,
                    disableTouchRipple: true,
                },
            } }, ComponentOverrides(theme)),
    });
    return createdTheme;
};

const isThemeValid = theme => {
    if (!theme) {
        logger.error("Feature Settings - Theme is not provided");
        return false;
    }
    return !validateSettings(new ThemeColor(), theme, "");
};
const validateSettings = (theme, themeToTest, parentKey) => {
    return Object.keys(theme).some(key => {
        const combinedKey = formatKey(parentKey, key);
        if (!themeToTest[key]) {
            logger.error(`Feature Setting - Theme: ${combinedKey} is not provided`);
            return true;
        }
        if (typeof theme[key] === "object") {
            return validateSettings(theme[key], themeToTest[key], combinedKey) > 0;
        }
        return false;
    });
};
const formatKey = (oldKey, newKey) => {
    return oldKey ? `${oldKey} - ${newKey}` : newKey;
};

const mockColors = {
    font: {
        primary: {
            regular: {
                family: '"AzoSansRegular"',
                filename: "AzoSans-Regular-webfont",
                formats: ["woff", "woff2"],
                weight: 700,
                letterSpacing: 1,
            },
            light: {
                family: '"AzoSans"',
                filename: "AzoSans-Light-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 400,
                letterSpacing: 1,
            },
            medium: {
                family: '"AzoSansMedium"',
                filename: "AzoSans-Medium-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 500,
                letterSpacing: 1,
            },
            italic: {
                family: '"AzoSansItalic"',
                filename: "AzoSans-Italic-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 400,
                letterSpacing: 1,
            },
            bold: {
                family: '"AzoSansBold"',
                filename: "AzoSans-Bold",
                formats: ["woff", "woff2", "eot"],
                weight: 600,
                letterSpacing: 1,
            },
            compressedMedium: {
                family: '"AzoSansBold"',
                filename: "AzoSans-Bold",
                formats: ["woff", "woff2", "eot"],
                weight: 600,
                letterSpacing: 1,
            },
            thin: {
                family: '"AzoSansBold"',
                filename: "AzoSans-Bold",
                formats: ["woff", "woff2", "eot"],
                weight: 400,
                letterSpacing: 1,
            },
        },
        secondary: {
            regular: {
                family: '"AzoSansRegular"',
                filename: "AzoSans-Regular-webfont",
                formats: ["woff", "woff2"],
                weight: 700,
            },
            light: {
                family: '"AzoSans"',
                filename: "AzoSans-Light-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 400,
            },
            medium: {
                family: '"AzoSansMedium"',
                filename: "AzoSans-Medium-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 500,
            },
            italic: {
                family: '"AzoSansItalic"',
                filename: "AzoSans-Italic-webfont",
                formats: ["woff", "woff2", "eot"],
                weight: 400,
            },
            bold: {
                family: '"AzoSansBold"',
                filename: "AzoSans-Bold",
                formats: ["woff", "woff2", "eot"],
                weight: 800,
            },
        },
        default: '"Helvetica Neue", Arial, sans-serif',
    },
    typography: {
        h1: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "1.125rem",
            letterSpacing: "0",
            lineHeight: "1.5",
            textDecoration: "none",
        },
        h2: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "1rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        h3: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.9375rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        h4: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        h5: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.8125rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        h6: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body1: {
            fontFamily: "Poppins",
            fontWeight: "regular",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body2: {
            fontFamily: "Poppins",
            fontWeight: "regular",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body3: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body4: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body5: {
            fontFamily: "Poppins",
            fontWeight: "400",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        body6: {
            fontFamily: "Poppins",
            fontWeight: "800",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        subtitle1: {
            fontFamily: "Poppins",
            fontWeight: "regular",
            textTransform: "none",
            fontSize: "1rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        subtitle2: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        overline: {
            fontFamily: "Poppins",
            fontWeight: "regular",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            letterSpacing: "1",
            lineHeight: "1.5",
        },
        caption: {
            fontFamily: "Poppins",
            fontWeight: "regular",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
    },
    component: {
        buttonMedium: {
            fontFamily: "Poppins",
            fontWeight: "700",
            textTransform: "none",
            fontSize: "1.125rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        buttonLarge: {
            fontFamily: "Poppins",
            fontWeight: "700",
            textTransform: "none",
            fontSize: "1.125rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
    },
    form: {
        buttonPrimary: {
            border: "0",
            background: "#30a74b",
            color: "#ffffff",
            radius: "0.25rem",
            opacity: "0.5",
            fontSize: "0.85rem",
            fontWeight: "400",
            textTransform: "none",
            letterSpacing: "0.0625rem",
        },
        buttonSecondary: {
            border: ".0625rem solid #000000",
            borderRadius: "1.375rem",
            background: "#ffffff",
            color: "#000000",
            radius: "0.25rem",
            opacity: "0.5",
            fontSize: "0.85rem",
        },
        buttonTertiary: {
            border: "0",
            background: "#000000",
            color: "#ffffff",
            radius: "0.25rem",
            opacity: "0.5",
            fontSize: "0.85rem",
        },
        input: {
            border: "0.0625rem solid #eaeaea",
            borderRadius: "0",
            borderBottom: "0.0625rem solid #eee",
            borderTop: "0.0625rem solid #eee",
            borderColor: "#949494",
            radius: "1.25rem",
            color: "#000000",
            background: "#f7f7f7",
            placeholder: "#515151",
            sortPlaceholder: "#515151",
            text: "inherit",
            focusActive: {
                background: "#ffffff",
                boxShadow: "0px 3px 4px 1px rgba(0, 0, 0, 0.4)",
                borderWidth: "2px",
                borderColor: "#000",
                border: "0.0625rem solid #ffffff",
            },
            hover: {
                background: "#ffffff",
                boxShadow: "0px 3px 4px 1px rgba(0, 0, 0, 0.4)",
                borderWidth: "1px",
                borderColor: "#000",
                border: "0.0625rem solid #000",
            },
        },
        default: {
            border: ".0625rem solid #9e9e9e",
            background: "#ffffff",
            radius: "0.25rem",
        },
        disabled: {
            border: ".0625rem solid #dedede",
            background: "#ffffff",
            radius: "0.25rem",
        },
        focusActive: {
            border: ".0625rem solid #000000",
            background: "#ffffff",
            radius: "0.25rem",
        },
        invalid: {
            border: ".0625rem solid #d91440",
            background: "#ffffff",
            radius: "0.25rem",
        },
        selectedAccent: {
            border: ".125rem solid #257F39",
            background: "#ffffff",
            radius: "0.25rem",
        },
        selectedBlock: {
            border: ".125rem solid #257F39",
            background: "rgba(255, 226, 216, 0.39)",
            radius: "0.25rem",
        },
        success: {
            border: ".0625rem solid #109449",
            background: "#ffffff",
            radius: "0.25rem",
        },
    },
    text: {
        default: "#000000",
        disabled: "#c5c5c5",
        reversed: "#ffffff",
        error: "#d91440",
        hyperlink: "#257f39",
        muted: "#515151",
        strong: "#000000",
        success: "#257f39",
        warning: "#d88f31",
        search: "#616161",
        navigation: {
            link: "#ffffff",
            linkActive: "#000000",
            linkClearance: "#f28500",
            fontWeight: 500,
        },
    },
    borders: {
        primary: {
            border: "0.0625rem solid #9e9e9e",
            radius: "0.125rem",
        },
        secondary: {
            border: "0.0625rem solid #9e9e9e",
            radius: "0.3125rem",
        },
    },
    palette: {
        primary: {
            main: "#007A7A",
            dark: "#006060",
            light: "#009393",
            contrastText: "#FFFFFF",
            shades: {
                disabled: "rgba(0, 122, 122, 0.3)",
            },
        },
        secondary: {
            main: "#000000",
            dark: "#000000",
            light: "#333333",
            contrastText: "#FFFFFF",
            shades: {
                disabled: "rgba(0, 0, 0, 0.3)",
            },
        },
        modal: {
            background: {
                primary: "#ffffff",
                secondary: "#f7f7f7",
            },
        },
        action: {
            disabledBorder: "#bdbdbd",
            enabledBorder: "#9e9e9e",
            disabledBackground: "#ffffff",
            enabledBackground: "#ffffff",
            disabled: "rgba(0,0,0,0.26)",
        },
        info: {
            main: "#1d89dd",
            other: {
                focusRingColor: "#1d89dd",
                focusBorderRadius: "0.8125rem",
            },
        },
        text: {
            primary: "rgba(0,0,0,0.87)",
            secondary: "#616161",
        },
        divider: "#eeeeee",
    },
    footer: {
        socialMedia: {
            background: "initial",
        },
        quickLinks: {
            background: "#f7f7f7",
        },
        mainLinks: {
            background: "#f7f7f7",
        },
        copyright: {
            background: "#f7f7f7",
        },
        accordians: {
            background: "#f7f7f7",
        },
    },
    header: {
        navUpperBackground: {
            default: "#000000",
            color: "#ffffff",
        },
        navLowerBackground: {
            default: "#1e1e1e",
            desktop: "#000000",
            active: "#ffffff",
            borderTop: "0",
            borderBottom: "0",
        },
        shoppingBag: {
            color: "#fff",
            fontWeight: "bold",
            fontSize: "0.688rem",
            promotionColor: "#000",
            deliveryColor: "#000",
            textTransform: "none",
            items: {
                backgroundColour: "#ffffff",
                fontSize: "0.75rem",
                color: "#000",
            },
            divider: {
                borderBottom: "0.0625rem solid rgba(238, 238, 238, 1)",
            },
        },
        myAccount: {
            background: "#fff",
            radius: "0.25rem",
            color: "#000",
            header: {
                backgroundColour: "#fff",
            },
            content: {
                textTransform: "none",
                backgroundColour: "#ffffff",
            },
            divider: {
                border: "1px solid #eaeaea",
            },
        },
        autoCompleteButton: {
            backgroundcolor: "#282828",
            color: "white",
            radius: "2px",
        },
        snailItemUnderline: {
            border: "0.0625rem solid white",
        },
        globalAppBar: {
            background: "#11426E",
        },
        upperHeader: {
            color: "#fff",
            fontSize: "0.75rem",
        },
        enrichedSearch: {
            background: "#ffffff",
        },
        simpleSearch: {
            marginTop: "0",
            padding: "0",
            radius: "0",
            boxShadow: "0",
        },
        burgerMenuQuickLinks: {
            background: "#f7f7f7",
            fontFamily: "Poppins",
            fontWeight: 400,
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0.0625rem",
            lineHeight: 1.5,
        },
        burgerMenu: {
            borderBottom: "1px solid #ffffff",
        },
        directLink: {
            fontSize: "0.875rem",
            fontWeight: "500",
        },
    },
    popover: {
        border: "0.0625rem solid #9e9e9e",
        radius: "0.25rem",
        backgroundColour: "#f7f7f7",
        fontSize: "0.75rem",
        boxShadow: "0px 3px 4px 1px rgba(0, 0, 0, 0.4)",
        header: {
            backgroundColour: "#f7f7f7",
            borderBottom: ".0625rem solid #d8d8d8",
        },
        arrow: {
            boxShadow: "0px 3px 4px 1px rgba(0, 0, 0, 0.4)",
            background: "#ffffff",
        },
    },
    utilities: {
        divider: "0.0625rem solid #eaeaea",
        dividerDark: ".0625rem solid #9e9e9e",
        backgroundAccent: "#f7f7f7",
        activeBorder: "0.125rem solid #257f39",
        chipBorderRadius: "0.25rem",
        background: {
            default: "#f7f7f7",
            paper: "#ffffff",
        },
    },
    drawer: {
        headerBorder: "#f7f7f7",
        headerBackground: ".0625rem solid #d8d8d8",
    },
    plp: {
        h1Count: {
            fontFamily: "Poppins",
            fontWeight: "medium",
            textTransform: "none",
            fontSize: "1.125rem",
            letterSpacing: "0",
            lineHeight: "1.5",
            textDecoration: "none",
        },
        tileLabel1: {
            fontFamily: "NimbusSanLBold",
            fontWeight: "400",
            textTransform: "none",
            fontSize: "0.75rem",
            letterSpacing: "0.0625rem",
            lineHeight: "1.125rem",
        },
        tileLabel2: {
            fontFamily: "NimbusSanLBold",
            fontWeight: "700",
            textTransform: "uppercase",
            fontSize: "0.75rem",
            letterSpacing: "0",
            lineHeight: "1.5rem",
        },
        tileLabel3: {
            fontFamily: "archivo-600",
            fontWeight: "600",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.3125rem",
        },
        tileLabel4: {
            fontFamily: "archivo-600",
            fontWeight: "600",
            textTransform: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.3125rem",
        },
        layout: {
            flexDirection: "initial",
            hasColourChips: "none",
            hasBrandName: "none",
        },
        listing: {
            textAlign: "left",
        },
        facetDivider: "0.0625rem solid #d1d1d1",
        filters: {
            titleTransform: "uppercase",
            clearBtnBorderWidth: "0",
        },
        colourChipSizes: {
            maxHeight: "2rem",
            maxWidth: "2rem",
            width: "1.5rem",
            height: "1.5rem",
            selectedHeight: "2.25rem",
            selectedWidth: "2.25rem",
        },
        searchBannerContainer: {
            backgroundColor: "#f7f7f7",
            ctasBorderRadius: "1rem",
            ctasBorder: "0.063rem solid #e6e6e6",
            ctasBorderBottom: "0.063rem solid #e6e6e6",
            roundelsBorder: "1px solid #9e9e9e",
            roundelsBorderRadius: "50%",
            textAlignment: "left",
            copyLineClamp: "1",
            fontSize: "0.875rem",
        },
        searchBanner: {
            default: {
                banner: {
                    root: {
                        backgroundColor: "rgba(247, 247, 247, 1)",
                    },
                    copyText: {
                        textColor: "rgba(0, 0, 0, 1)",
                        link: {
                            primary: {
                                enabled: {
                                    contrastTextColor: "rgba(127, 61, 155, 1)",
                                    hovered: {
                                        contrastTextColor: "rgba(127, 61, 155, 1)",
                                    },
                                },
                            },
                        },
                    },
                    chips: {
                        outlined: {
                            enabled: {
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                borderColor: "rgba(148, 148, 148, 1)",
                                contrastTextColor: "rgba(0, 0, 0, 1)",
                            },
                            hovered: {
                                backgroundColor: "rgba(247, 247, 247, 1)",
                                borderColor: "rgba(0, 0, 0, 1)",
                                contrastTextColor: "rgba(0, 0, 0, 1)",
                            },
                        },
                    },
                    imageChips: {
                        backgroundColor: "rgba(247, 247, 247, 1)",
                        textColor: "rgba(0, 0, 0, 1)",
                        enabled: {
                            borderColor: "rgba(148, 148, 148, 1)",
                        },
                        hovered: {
                            borderColor: "rgba(66, 66, 66, 1)",
                        },
                    },
                },
                stripBanner: {
                    backgroundColor: "rgba(254, 208, 61, 1)",
                    borderColor: "rgba(224, 224, 224, 0)",
                    button: {
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        borderColor: "rgba(0, 0, 0, 1)",
                        contrastTextColor: "rgba(0, 0, 0, 1)",
                    },
                    typography: {
                        textColor: "rgba(0, 0, 0, 1)",
                    },
                },
            },
            searchListItemLabel: {
                fontFamily: "poppins-500",
                fontWeight: "500",
                textTransform: "none",
                textDecoration: "none",
                fontSize: "0.75rem",
                letterSpacing: "0",
                lineHeight: "1.5",
            },
            chip: {
                fontFamily: "poppins-400",
                fontWeight: 400,
                border: "none",
                textTransform: "none",
                textDecoration: "none",
                fontSize: "0.8125rem",
                letterSpacing: 1,
                lineHeight: 1.5,
                small: {
                    borderRadius: "12px",
                },
                medium: {
                    borderRadius: "16px",
                },
            },
            imageChip: {
                default: {
                    borderRadius: "100px",
                },
            },
        },
    },
    countrySelect: {
        logoPosition: "flex-start",
        headerBarHeight: "2.75rem",
        headerBackground: "#000000",
        headerBorderBottom: "none",
        accordionHeaderTransform: "capitalize",
        accordionHeaderLetterSpacing: "0.0075rem",
    },
    checkbox: {
        border: {
            default: "0.063rem solid",
            active: "0.125rem solid",
            radius: "0.25rem",
        },
        size: "1rem",
    },
    other: {
        ratingHover: "#424242",
        ratingInactive: "#E0E0E0",
        ratingActive: "#000000",
        notification: "#EC008C",
        divider: "#EEEEEE",
    },
    accordion: {
        background: "#fff",
        border: {
            width: "1px 0",
            color: "#EEEEEE",
            radius: "0",
            style: "solid",
        },
        accordionDetailsPadding: "0 0 1rem 0",
    },
    select: {
        borderRadius: "1.375rem",
        borderColor: "#9e9e9e",
    },
    components: {
        borderRadius: "1.375rem",
        tabText: {
            fontSize: "0.875rem",
            fontFamily: "BentonSans Medium",
            fontWeight: "400",
            textTransform: "none",
            letterSpacing: "normal",
        },
        tab: {
            nav: {
                default: {
                    active: {
                        highlightColor: "rgba(0, 0, 0, 1)",
                    },
                },
            },
        },
        inputLabel1: {
            fontFamily: "DM Sans",
            fontWeight: "400",
            textTransform: "none",
            textDecoration: "none",
            fontSize: "0.875rem",
            letterSpacing: "0",
            lineHeight: "1.5",
        },
        inputLabel2: {
            fontFamily: "DM Sans",
            fontWeight: "400",
            fontSize: "0.75rem",
            lineHeight: "1.5",
            textTransform: "capitalize",
        },
        buttonLarge: {
            fontFamily: "DM Sans",
            fontWeight: "400",
            fontSize: "0.75rem",
            lineHeight: "1.5",
            textTransform: "capitalize",
            letterSpacing: "1",
        },
        buttonMedium: {
            fontFamily: "DM Sans",
            fontWeight: 400,
            fontSize: "0.75rem",
            lineHeight: 1.5,
            textTransform: "capitalize",
            letterSpacing: "1",
        },
        buttonGroup: {
            default: {
                borderTopColor: "#9e9e9e",
                borderBottomColor: "#9e9e9e",
            },
        },
        toggleButton: {
            selected: {
                default: {
                    background: "#9e9e9e",
                    borderColor: "#9e9e9e",
                },
            },
        },
        dialog: {
            dialogHeader: {
                default: {
                    backgroundColor: "rgba(247, 247, 247, 1)",
                    borderColor: "rgba(238, 238, 238, 1)",
                    textColor: "rgba(0, 0, 0, 1)",
                    iconColor: "rgba(0, 0, 0, 1)",
                },
            },
        },
        link: {
            primary: {
                enabled: {
                    color: "rgba(0, 0, 0, 1)",
                    textColor: "rgba(127, 61, 155, 1)",
                },
            },
        },
        button: {
            outlined: {
                secondary: {
                    enabled: {
                        contrastTextColor: "rgba(0, 0, 0, 1)",
                    },
                },
            },
        },
        inputText: {
            fontFamily: '"AzoSans"',
            fontSize: "0.75rem",
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: "0",
        },
        chips: {
            filled: {
                newin: {
                    enabled: {
                        backgroundColor: "transparent",
                        color: "#000000",
                    },
                },
            },
        },
        chipLabel2: {
            fontFamily: "AzoSansMedium",
            fontWeight: 500,
            textTransform: "uppercase",
            textDecoration: "none",
            fontSize: "0.6875rem",
            letterSpacing: "0.0313rem",
            lineHeight: "1.5rem",
        },
        breadcrumb: {
            default: {
                backgroundColor: "rgba(247, 247, 247, 1)",
                borderBottomColor: "rgba(238, 238, 238, 1)",
                borderTopColor: "rgba(238, 238, 238, 1)",
                gradientLeft: "linear-gradient(to right, rgba(247, 247, 247, 1), rgba(247, 247, 247, 0))",
                gradientRight: "linear-gradient(to right, rgba(247, 247, 247, 0), rgba(247, 247, 247, 1))",
                button: {
                    enabled: {
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        borderTopColor: "rgba(238, 238, 238, 0)",
                        borderBottomColor: "rgba(238, 238, 238, 0)",
                        borderLeftColor: "rgba(238, 238, 238, 1)",
                        borderRightColor: "rgba(238, 238, 238, 1)",
                        contrastTextColor: "rgba(0, 0, 0, 1)",
                        iconColor: "rgba(0, 0, 0, 1)",
                    },
                    hovered: {
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        borderTopColor: "rgba(238, 238, 238, 0)",
                        borderBottomColor: "rgba(238, 238, 238, 0)",
                        borderLeftColor: "rgba(238, 238, 238, 1)",
                        borderRightColor: "rgba(238, 238, 238, 1)",
                        contrastTextColor: "rgba(0, 0, 0, 1)",
                        iconColor: "rgba(0, 0, 0, 1)",
                    },
                },
            },
        },
        backToNext: {
            default: {
                backgroundColor: "rgba(0, 0, 0, 1)",
                textColor: "rgba(255, 255, 255, 1)",
                iconColor: "rgba(255, 255, 255, 1)",
            },
        },
        menu: {
            default: {
                root: {
                    borderColor: "rgba(222, 222, 222, 1)",
                    backgroundColor: "rgba(255, 255, 255, 1)",
                },
                disabled: {
                    textColor: "rgba(179, 179, 179, 1)",
                },
                hovered: {
                    backgroundColor: "rgba(102, 102, 102, 1)",
                    textColor: "rgba(255, 255, 255, 1)",
                },
                selected: {
                    backgroundColor: "rgba(102, 102, 102, 1)",
                    textColor: "rgba(255, 255, 255, 1)",
                },
                enabled: {
                    textColor: "rgba(0, 0, 0, 1)",
                },
            },
            megaMenu: {
                mission: {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    textColor: "rgba(0, 0, 0, 1)",
                },
            },
        },
        appBar: {
            brandBar: {
                default: {
                    tab: {
                        default: {
                            enabled: {
                                borderColor: "rgba(0, 0, 0, 1)",
                            },
                            active: {
                                borderColor: "rgba(0, 0, 0, 1)",
                            },
                        },
                    },
                },
            },
        },
        saleClearance: {
            sale: {
                bannerBackgroundColour: "rgba(245, 245, 245, 1)",
                sashColour: "rgba(208, 26, 66, 1)",
            },
            clearance: {
                bannerBackgroundColour: "rgba(243, 221, 193, 1)",
                sashColour: "rgba(239, 122, 34, 1)",
            },
        },
    },
    backdrop: {
        default: {
            main: "rgba(0, 0, 0, 0.5)",
        },
    },
    brand: {
        sale: {
            default: {
                textColor: "rgba(208, 26, 66, 1)",
            },
        },
        markdown: {
            default: {
                textColor: "rgba(45, 5, 150, 1)",
            },
        },
        success: {
            default: {
                textColor: "rgba(37, 127, 57, 1)",
            },
        },
    },
    background: {
        default: "#ffffff",
        paper: {
            background: "rgba(208, 26, 66, 1)",
        },
    },
    action: {
        default: {
            enabled: {
                background: "rgba(208, 26, 66, 1)",
                borderColor: "#000",
            },
        },
        focused: {
            border: "#000",
        },
        disabled: {
            border: "#bdbdbd",
        },
    },
    light: {
        text: {
            primary: "#000000",
            secondary: "#000000",
        },
    },
    grey: {
        50: "rgba(250, 250, 250, 1)",
        100: "rgba(245, 245, 245, 1)",
        300: "rgba(224, 224, 224, 1)",
        500: "rgba(158, 158, 158, 1)",
        700: "rgba(97, 97, 97, 1)",
    },
};
const mockTheme = createTheme({ styles: "", colours: mockColors, direction: "ltr" });

export { FONTS, ThemeColor, breakpoints, buildFont, fontBuilder, isThemeValid, mockColors, mockTheme, nextMaterialUITheme };
